import React from "react"
import { Grid, IconButton } from "@material-ui/core"
import { Add, Remove } from "@material-ui/icons"

import { SectionContainer, ButtonsContainer } from "./styles"
import { FormHelperText, FormTextField } from "@/components/Form"
import { useControlledArray } from "@/hooks"

import { toMask } from "@/services/masks"
import { telefoneFixo } from "@/consts/regexp"

export function BanksRefs() {
  const { data, add, remove } = useControlledArray([{ id: "0" }])

  function handleAdd(index) {
    const newRegister = {
      id: String(index + 1),
    }

    add(newRegister)
  }

  return (
    <SectionContainer>
      {data.map((register, index) => {
        const disabledAddButton = index !== data.length - 1
        const disabledRemoveButton = data.length === 1 || disabledAddButton

        return (
          <Grid key={register.id} container spacing={2} alignItems="flex-start">
            <Grid item xs={4}>
              <FormTextField
                fullWidth
                label="Nome"
                size="small"
                variant="outlined"
                name={`banks_refs.${index}.dsc_inf_referencia_banc`}
              />
            </Grid>
            <Grid item xs={4}>
              <FormTextField
                fullWidth
                label="Contato"
                size="small"
                variant="outlined"
                name={`banks_refs.${index}.eir_contato_banc`}
              />
            </Grid>
            <Grid item xs={3}>
              <FormTextField
                fullWidth
                label="Phone"
                size="small"
                variant="outlined"
                name={`banks_refs.${index}.eir_fone_banc`}
                textMaskProps={toMask(telefoneFixo.array)}
              />
            </Grid>
            <Grid item xs={1}>
              <ButtonsContainer>
                <IconButton
                  disabled={disabledAddButton}
                  color="primary"
                  title="Adicionar"
                  size="small"
                  onClick={() => handleAdd(index)}
                >
                  <Add />
                </IconButton>

                <IconButton
                  disabled={disabledRemoveButton}
                  className="remove"
                  title="Remover"
                  size="small"
                  onClick={() => remove(register.id)}
                >
                  <Remove />
                </IconButton>
              </ButtonsContainer>
            </Grid>
          </Grid>
        )
      })}

      <FormHelperText name="banks_refs" />
    </SectionContainer>
  )
}
